import { ProductDescription } from './ProductDescription';

export type { TypeProductDescriptionProps } from './types';
export default ProductDescription;
